import React, {useState, useEffect} from 'react';
import {
    Button,
    TextField,
    MenuItem,
    Select,
    InputLabel,
    FormControl,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle, Tooltip
} from '@mui/material';
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";
import axios from "axios";

const EditDocumentModal = ({open, handleClose, documentData, fetchDocuments}) => {
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [name, setName] = useState('');
    const [language, setLanguage] = useState('');
    const [file, setFile] = useState(null);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);


    const handleSave = async ({id, name, language, file}) => {
        const fileReader = new FileReader();
        fileReader.readAsDataURL(file);
        fileReader.onload = async () => {
            const base64String = fileReader.result.split(',')[1];
            try {
                const response = await axios.put(`${baseURL}/EditDocumentDrive`, {
                    id,
                    name,
                    description: '',
                    language,
                    file: {
                        base64String,
                        ext: "pdf"
                    }
                });
                if (response.data.success) {
                    await fetchDocuments();
                    setPreviewUrl(null)
                    setIsConfirmModalOpen(false)
                } else {
                    alert('Failed to edit document');
                }
            } catch (error) {
                console.error('Failed to edit document', error);
            }
        };
    };

    useEffect(() => {
        if (documentData) {
            setName(documentData.name);
            setLanguage(documentData.language);
        }
    }, [documentData]);

    const handleFileChange = event => {
        const selectedFile = event.target.files[0];
        if (selectedFile) {
            setFile(selectedFile);
            setPreviewUrl(URL.createObjectURL(selectedFile));
        }
    };

    const saveChanges = () => {
        void handleSave({id: documentData.id, name, language, file});
        handleClose();
    };
    const openConfirmationModal = () => {
        setIsConfirmModalOpen(true)
    };

    return (
        <Dialog open={open} onClose={handleClose} fullWidth width="xs">
            <DialogTitle>რედაქტირება</DialogTitle>
            <DialogContent>
                <TextField
                    margin="dense"
                    label="ფაილის სახელი"
                    type="text"
                    fullWidth
                    variant="outlined"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                />

                <FormControl fullWidth margin="dense">
                    <InputLabel>ენა</InputLabel>
                    <Select
                        value={language}
                        onChange={(e) => setLanguage(e.target.value)}
                        label="ენა"
                    >
                        <MenuItem value="ქართული">ქართული</MenuItem>
                        <MenuItem value="ინგლისური">ინგლისური</MenuItem>
                    </Select>
                </FormControl>
                {previewUrl && (
                    <iframe src={previewUrl} style={{width: '100%', height: '500px'}}></iframe>
                )}
                <Button
                    variant="contained"
                    component="label"
                    fullWidth
                    margin="dense"
                >
                    ატვირთვა
                    <input
                        type="file"
                        hidden
                        onChange={handleFileChange}
                        accept=".pdf"
                    />
                </Button>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>გაუქმება</Button>
                <Tooltip title={name === '' ? "შეიყანეთ ფაილის სახელი" : previewUrl === null ? "ატვირთეთ ფაილი" : ""}>
                    <div>
                        <Button
                            disabled={name === '' || previewUrl === null}
                            onClick={openConfirmationModal}
                            color="primary">შენახვა
                        </Button>
                    </div>
                </Tooltip>
            </DialogActions>
            <ConfirmationModal
                isOpen={isConfirmModalOpen}
                onRequestClose={() => setIsConfirmModalOpen(false)}
                onConfirm={saveChanges}
            />
        </Dialog>
    );
};

export default EditDocumentModal;
